import { render, staticRenderFns } from "./UserFamilyCards.vue?vue&type=template&id=503a505e&"
import script from "./UserFamilyCards.vue?vue&type=script&lang=js&"
export * from "./UserFamilyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports